import { ContactPersonDto } from "../../autogen/bff-api";
import { normalizeEmail } from "../email/normalizeEmail";

/** Keeps the first item per email, normalized (trimmed, case-insensitive) so the same address never appears twice. */
export const dedupeByEmail = <T>(items: T[], emailOf: (item: T) => string): T[] => {
  const seen = new Set<string>();
  return items.filter((item) => {
    const key = normalizeEmail(emailOf(item));
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
};

/** A supplier's buyer-managed contacts: those on the registered organization plus any on its linked entries. */
export const supplierContactPersons = (
  registeredOrgContacts: ContactPersonDto[],
  linkedEntries: { contactPersons?: ContactPersonDto[] | null }[],
  accountPersons: { email: string }[] = [],
  chosenEmails: string[] = []
): ContactPersonDto[] => {
  const chosen = new Set(chosenEmails.map(normalizeEmail));
  const accountEmails = new Set(accountPersons.map((person) => normalizeEmail(person.email)));
  return dedupeByEmail(
    [...registeredOrgContacts, ...linkedEntries.flatMap((entry) => entry.contactPersons ?? [])],
    (p) => p.email
  ).filter((contact) => chosen.has(normalizeEmail(contact.email)) || !accountEmails.has(normalizeEmail(contact.email)));
};
